module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.saving) ? _c('div', {
    staticClass: "saving"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "holder",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "navigation",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "plan-item__title"
  }, [_vm._v("Планировка помещения")]), _vm._v(" "), _c('div', {
    staticClass: "plan-item-variants"
  }, [_c('a', {
    staticClass: "plan-item-section plan-item-section--wall",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Стены")]), _vm._v(" "), _c('a', {
    staticClass: "plan-item-section plan-item-section--partition",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addPartition.apply(null, arguments)
      }
    }
  }, [_vm._v("Перегородки")])]), _vm._v(" "), _c('div', {
    staticClass: "plan-item__title"
  }, [_vm._v("Расстановка мебели")]), _vm._v(" "), _c('div', {
    staticClass: "shelf-items"
  }, _vm._l((_vm.rackprototypesTransformed), function(rack) {
    return _c('div', {
      staticClass: "shelf-item",
      on: {
        "dblclick": function($event) {
          return _vm.addRack(rack)
        }
      }
    }, [_c('div', {
      staticClass: "shelf-item__icon"
    }, [_c('img', {
      attrs: {
        "src": "/static/shelf-normal.png",
        "width": "16",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "shelf-item__rack-count"
    }, [_vm._v(_vm._s(rack.shelfCount))])]), _vm._v(" "), _c('div', {
      staticClass: "shelf-item__title"
    }, [_vm._v(_vm._s(rack.title) + " " + _vm._s(rack.width) + "x" + _vm._s(rack.height) + "x" + _vm._s(rack.depth) + " мм")]), _vm._v(" "), _c('router-link', {
      staticClass: "shelf-item__edit",
      attrs: {
        "to": ("/racks/" + (rack.id) + "/edit/")
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "editor-field",
    attrs: {
      "title": ""
    },
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseup
    }
  }, [_c('div', {
    staticClass: "plan-holder",
    attrs: {
      "title": ""
    },
    on: {
      "click": _vm.planHolderClick
    }
  }, [_vm._l((_vm.draggablePoints), function(point, index) {
    return _c('draggable-point', {
      attrs: {
        "top": point.y,
        "left": point.x,
        "type": point.type,
        "insertPos": point.insertPos,
        "lineIndex": point.lineIndex,
        "id": point.id
      },
      on: {
        "mousedown": _vm.mousedown,
        "remove": _vm.remove
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "added-racks"
  }, [_vm._l((_vm.racks), function(rack, key) {
    return _c('rack-on-plan', {
      attrs: {
        "width": rack.prototype.width,
        "depth": rack.prototype.depth,
        "left": rack.startX,
        "top": rack.startY,
        "angle": rack.angle,
        "id": rack.id,
        "title": rack.title,
        "isExt": rack.isExt,
        "sort": rack.sort ? rack.sort : 100,
        "selected": false
      },
      on: {
        "mousedown": _vm.mousedown,
        "contextmenu": _vm.contextmenu,
        "dblclick": function($event) {
          return _vm.removeRack(key)
        }
      }
    })
  }), _vm._v(" "), (_vm.angleVisible) ? _c('div', {
    staticClass: "angle-block",
    style: (_vm.angleBlock)
  }, [_c('div', {
    staticClass: "rack-on-plan__title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rackTitle),
      expression: "rackTitle"
    }],
    staticClass: "title-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rackTitle)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rackTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sort-and-ext"
  }, [_c('div', {
    staticClass: "ext-config"
  }, [_c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Выносной")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isExt),
      expression: "isExt"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "name": "selected-variant",
      "id": "auto"
    },
    domProps: {
      "checked": Array.isArray(_vm.isExt) ? _vm._i(_vm.isExt, null) > -1 : (_vm.isExt)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "change": function($event) {
        var $$a = _vm.isExt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isExt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isExt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isExt = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sort-config"
  }, [_c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rackSort),
      expression: "rackSort",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.rackSort)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rackSort = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title-and-angle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.angleValue),
      expression: "angleValue",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "min": "0",
      "max": "360",
      "step": "5"
    },
    domProps: {
      "value": (_vm.angleValue)
    },
    on: {
      "__r": function($event) {
        _vm.angleValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "angle-block-value"
  }, [_vm._v(_vm._s(_vm.angleValue) + "˚")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-links"
  }, [_vm._v("\n              Скопировать\n              "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyRackWithItems()
      }
    }
  }, [_vm._v("в эту же")]), _vm._v(" или\n              "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyRackWithItemsToOtherPharmacy()
      }
    }
  }, [_vm._v("в другую аптеку")])])]) : _vm._e()], 2), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  }), _vm._v(" "), _vm._l((_vm.partitions), function(partition, index) {
    return _c('path', {
      attrs: {
        "d": partition.str
      }
    })
  })], 2), _vm._v(" "), _vm._l((_vm.guides), function(line) {
    return _c('line', {
      attrs: {
        "x1": line.x1,
        "y1": line.y1,
        "x2": line.x2,
        "y2": line.y2,
        "stroke": "red",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _c('g', _vm._l((_vm.guides), function(line) {
    return _c('text', {
      attrs: {
        "x": (line.x1 + line.x2) / 2 - 30,
        "y": (line.y1 + line.y2) / 2 - 20
      }
    }, [_vm._v("\n              " + _vm._s(Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1), 2))) + " см\n            ")])
  }), 0)], 2)], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-400a5227","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pharmacy/PharmacyEdit.vue
// module id = 240
// module chunks = 1